var _rect, _path, _path2, _path3, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#EEF8F1",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#139C33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M8.07 13.222h12.975M14.752 22.667c-1.727 0-3.127-3.172-3.127-7.084 0-3.912 1.4-7.083 3.127-7.083M15.166 17.944H8.07"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#139C33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M14.747 8.5a7.083 7.083 0 1 0 0 14.167M21.417 20.167H19.75M17.877 15.583c0-3.912-1.4-7.083-3.127-7.083"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#139C33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M21.833 15.583A7.083 7.083 0 0 0 14.75 8.5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.667,
    height: 5.833,
    x: 17.25,
    y: 17.667,
    stroke: "#139C33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    rx: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipType);
export default __webpack_public_path__ + "static/media/ship-type.d600d643f0c51286a46e1b604785c671.svg";
export { ForwardRef as ReactComponent };